import { UserHydration } from '@components/guards/UserHydration';
import { BALoader } from '@components/loader/BALoader';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from 'next-themes';
import { useEffect } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { LangProvider } from './i18n/LangProvider';
import { AppRouter } from './routes/router';
import { persistor, store } from './store';
import buildProvidersTree from './utils/ProviderTree';

const queryClient = new QueryClient();

const ProvidersTree = buildProvidersTree([
  [QueryClientProvider, { client: queryClient }],
  [Provider, { store }],
  [ThemeProvider, { defaultTheme: 'atlantida' }],
]);

export function App() {
  useEffect(() => {
    document.title = 'Atlántida - Onboarding';
  }, []);

  return (
    <ProvidersTree>
      <PersistGate loading={<BALoader />} persistor={persistor}>
        <LangProvider>
          <UserHydration>
            <AppRouter />
          </UserHydration>
        </LangProvider>
      </PersistGate>
    </ProvidersTree>
  );
}
